import { render, staticRenderFns } from "./alarqam_layout.vue?vue&type=template&id=5d05694e&scoped=true&"
import script from "./alarqam_layout.vue?vue&type=script&lang=js&"
export * from "./alarqam_layout.vue?vue&type=script&lang=js&"
import style0 from "./alarqam_layout.vue?vue&type=style&index=0&id=5d05694e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05694e",
  null
  
)

export default component.exports